import { useEffect, useState } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import { Button, message } from 'antd';
import { DatePicker } from 'antd';
import dayjs from "dayjs";
import { freezePlan } from "../apis/plansApi";
import Features from "../enums/features";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const FreezePLanModal = ({open, userPlanId, onSuccess, onClose}) => {
    const [freezeFrom, setFreezeFrom] = useState(null);
    const [freezeTo, setFreezeTo] = useState(null);
    const [indefinite, setIndefinite] = useState(false);
    const [isFreezeIndefinitelyEnabled, setIsFreezeIndefinitelyEnabled] = useState(false);

    useEffect(() => {
        function checkFeatures() {
            const features = JSON.parse(localStorage.getItem('user_features') || '{}');
            setIsFreezeIndefinitelyEnabled(features[Features.FREEZE_INDEFINITELY] || false);
        }
        checkFeatures();
    }, []);

    if (!open || !userPlanId) return null;

    const handleSetIndefinite = (checked) => {
        setIndefinite(checked);
        setFreezeTo(null);
    }

    const handleSubmit = async () => {
        try {
            const response = await freezePlan(userPlanId, freezeFrom, freezeTo || null, null, false);

            if (response.status === 200) {
                onSuccess();
            } else {
                throw new Error("UNEXPECTED_STATUS");
            }
        } catch (error) {
            const status = error.response?.status;
            const backendMessage = error.response?.data?.message;

            if (status === 400 && backendMessage) {
                message.error(`Error al congelar el plan. ${backendMessage}`);
            } else {
                message.error("Error al congelar el plan. Contacta a soporte.");
            }
        } finally {
            onClose();
        }
    };

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Congelar Plan</h5>
                        <button type="button" className="close" onClick={onClose} aria-label="Close">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body w-50 text-left mx-auto">
                        <DatePicker
                            placeholder="Desde"
                            value={freezeFrom}
                            onChange={setFreezeFrom}
                            /* disabledDate={(current) => current && current < dayjs().tz(dayjs.tz.guess()).startOf("day")} /* Do not use moment and minDate it causes a bug changing the date*/
                            format="DD/MM/YYYY"
                            getPopupContainer={(trigger) => trigger.parentNode}
                            className="d-block m-auto"
                        />

                        {!indefinite && (
                            <DatePicker
                                placeholder="Hasta"
                                value={freezeTo}
                                onChange={setFreezeTo}
                                /*disabledDate={(current) => current && current < dayjs.utc().startOf("day")} /* Do not use moment and minDate it causes a bug changing the date*/
                                format="DD/MM/YYYY"
                                getPopupContainer={(trigger) => trigger.parentNode}
                                className="d-block mt-3 mx-auto"
                            />
                        )}

                        {/* Indefinite checkbox */}
                        {isFreezeIndefinitelyEnabled && (
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={indefinite}
                                    onChange={(e) => handleSetIndefinite(e.target.checked)}
                                />
                                }
                                label="Indeterminado"
                            />
                        )}
                    </div>
                    <div className="modal-footer">
                        <Button onClick={onClose}>Cancelar</Button>
                        <Button variant="contained" onClick={handleSubmit}>Guardar</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FreezePLanModal;